export const shopPhoneNumberPrefixes = [
  { country: 'Germany', iso: 'DE', code: '+49' },
  { country: 'Austria', iso: 'AT', code: '+43' },
  { country: 'Luxemburg', iso: 'LU', code: '+352' },
  { country: 'Netherlands', iso: 'NL', code: '+31' },
  { country: 'Portugal', iso: 'PT', code: '+351' },
  { country: 'Spain', iso: 'ES', code: '+34' },
] as const

export type PhonePrefix = (typeof shopPhoneNumberPrefixes)[number]['code']
